import { QuoteTemplateLineItem } from "./quote-template";
import { LineItem } from "./line-item";

// Mapping functions to convert between form model and API model
export function toApiModel(lineItem: LineItem): QuoteTemplateLineItem {
  return {
    ntiid: lineItem.id,
    ntitrackingid: lineItem.trackingId,
    ntitype: lineItem.type,
    ntititle: lineItem.title,
    ntidesc: lineItem.type === "GroupStart" 
      ? lineItem.groupName 
      : lineItem.description,
    ntiqty: lineItem.quantity,
    ntiunit: lineItem.unit,
    nticost: lineItem.unitCost ? lineItem.unitCost.toString() : null,
    ntimarkup: lineItem.markup ? lineItem.markup.toString() : null,
    ntitax: lineItem.applyTax ? 1 : 0,
    mid: lineItem.materialTypeId,
    miid: lineItem.materialStyleId,
    mpid: lineItem.materialSupplierId,
    lcid: lineItem.laborCategoryId,
    ltid: lineItem.laborTypeId,
    ntitypeid: lineItem.typeId,
    ntiorder: lineItem.order,
    mstyle: lineItem.materialStyle,
    ntisectionid: lineItem.sectionId,
    ntimfid: lineItem.appliedFormulaId,
    ntiparenttexttrackingid: lineItem.parentTextTrackingId,
  };
}

export function fromApiModel(apiModel: QuoteTemplateLineItem): LineItem {
  return {
    id: apiModel.ntiid,
    trackingId: apiModel.ntitrackingid || crypto.randomUUID(),
    type: apiModel.ntitype || "",
    title: apiModel.ntititle,
    description: apiModel.ntitype === "GroupStart" ? null : apiModel.ntidesc,
    quantity: apiModel.ntiqty ?? null,
    unit: apiModel.ntiunit,
    unitCost: apiModel.nticost ? Number(apiModel.nticost) : null,
    cost: null,
    markup: apiModel.ntimarkup ? Number(apiModel.ntimarkup) : null,
    applyTax: !!apiModel.ntitax,
    excludeAdditionalMarkup: false,
    materialTypeId: apiModel.mid ?? null,
    materialStyleId: apiModel.miid ?? null,
    materialSupplierId: apiModel.mpid ?? null,
    laborCategoryId: apiModel.lcid ?? null,
    laborTypeId: apiModel.ltid ?? null,
    typeId: apiModel.ntitypeid,
    useQuoteFile: false,
    useClaimFile: false,
    useWorkOrderFile: false,
    date: null,
    accepted: false,
    initials: null,
    reason: null,
    reasonNotes: null,
    order: apiModel.ntiorder ?? null,
    materialStyle: apiModel.mstyle ?? null,
    groupName: apiModel.ntitype === "GroupStart" ? apiModel.ntidesc : null,
    sectionId: apiModel.ntisectionid,
    appliedFormulaId: apiModel.ntimfid,
    parentTextTrackingId: apiModel.ntiparenttexttrackingid,
  };
} 